import React, { useEffect, useState } from "react";
import { AvForm} from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row, Label } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import moment from "moment";
import { CircularProgress } from "@material-ui/core";


const EditRibbon = (props) => {

  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const [content, setContent] = useState();
  // const [version, setVersion] = useState();
  const [status, setStatus] = useState(statusOptions[0].value);
  const [navigation, setNavigation] = useState();
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [neverEnding, setNeverEnding] = useState(false);
  const [publishDate, setPublishDate] = useState();
  const [unPublishDate, setUnPublishDate] = useState();
  const [loader,setLoader]=useState(false)



  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);

    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      // var page = props.location.state?.item?.page;
      var content = props.location.state?.item?.content;
      var navigation = props.location.state?.item?.navigate_to;
      // var version = props.location.state?.item?.item_version;
      var status = props.location.state?.item?.item_status;
      var publishDate = props.location.state?.item?.published_at;
      var unPublishDate = props.location.state?.item?.unpublished_at;

      if (unPublishDate=="null" || !unPublishDate) {
        console.log("here is the unpublished date------->",unPublishDate)
        setNeverEnding(!neverEnding);
        setUnPublishDate("");
      } else {
        setUnPublishDate(moment(unPublishDate).format("YYYY-MM-DDTHH:mm"));
      }
      // setPage(page);
      setContent(content);
      setNavigation(navigation);
      // setVersion(version);
      setStatus(status);
      setPublishDate(moment(publishDate).format("YYYY-MM-DDTHH:mm"));
    }
  }, []);

  const handleEdit = () => {
    if (!content) {
      setErrorMessage("Please Enter Content");
      setErrorAlert(true);
      return;
    } else if (!neverEnding) {
      if(unPublishDate == "Invalid date" || !unPublishDate){
      setErrorMessage("Please select unpublish date")
      setErrorAlert(true)
      return
         }
      else if(unPublishDate < publishDate){
      setErrorMessage("Unpublish date should be after the publish date")
      setErrorAlert(true)
      return
      }
    }
     else if (!status) {
      setErrorMessage("Please Select Status");
      setErrorAlert(true);
      return;
    }
    setLoader(true)
    // let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("item_id", propsData?.item?.item_id);
    formdata.append("path", "ribbons/update");
    formdata.append("page", "Home");
    formdata.append("content",content)
    formdata.append("navigate_to", JSON.stringify({}));
    formdata.append("item_type","ribbon");
    formdata.append("item_version",18)
    formdata.append("item_status",status)
    formdata.append("published_at", publishDate);
    formdata.append("unpublished_at", neverEnding ? null : unPublishDate);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/ribbons");
        }}
        onConfirm={() => {
          props?.history.push("/ribbons");
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {props?.location?.state?.edit?"Ribben Updated Successfully":"Ribbon Added Successfully"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Edit Ribbon" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        {/* <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Page</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="page_input"
                                  onChange={(e) => {
                                    setPage(e.target.value);
                                  }}
                                  defaultValue={page}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row> */}
                        <Row>
                          <Col lg={6} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Content</Label>
                              <div className="col-md-12">
                                <textarea
                              rows="3" 
                              cols="30"
                                  className="form-control"
                                  type="text"
                                  id="Content_input"
                                  onChange={(e) => {
                                    setContent(e.target.value);
                                  }}
                                  defaultValue={content}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        {/* <Row>
                          <Col lg={6} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Navigate To</Label>
                              <div className="col-md-12">
                                <textarea
                                rows="3" 
                                cols="30"
                                  className="form-control"
                                  type="text"
                                  id="navigation-input"
                                  onChange={(e) =>
                                    setNavigation(e.target.value)
                                  }
                                  // placeholder="https://grabPay.com/pay"
                                  defaultValue={navigation}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row> */}
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Publish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={publishDate}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Unpublish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setUnPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={unPublishDate}
                                  disabled={neverEnding}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col style={{ paddingTop: 35 }}>
                            <div className="form-check form-switch">
                              <input
                                type="checkbox"
                                className="form-check-input checkbox"
                                id="checkbox_1"
                                checked={neverEnding}
                                onChange={() => {
                                  setNeverEnding(!neverEnding);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="checkbox_1"
                              >
                                Never-ending
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                // value={selectedStatus}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={status ? status=="Y" ? "Enable":"Disable" : "Choose..."}
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                          {/* <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Version</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  onChange={(e) => {
                                    setVersion(e.target.value);
                                  }}
                                  type="number"
                                  id="version_input"
                                  defaultValue={version}
                                  placeholder={18}
                                />
                                <small className="text-muted user-select-none">
                                  For mobile app only
                                </small>
                              </div>
                            </div>
                          </Col> */}
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/ribbons");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                            handleEdit();
                       }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                        {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditRibbon;
